import type { ReactNode } from 'react'
import * as React from 'react'
import useOfferPageWalledGarden from 'hooks/OfferPage/useOfferPageWalledGarden'

interface Props {
  offerType?: App.OfferType
  wall?: ReactNode
  bypassWall?: boolean
  children?: React.ReactNode
}

function SoftOfferPageWalledGarden({
  offerType,
  wall,
  bypassWall,
  children,
}: Props) {
  const showWall = useOfferPageWalledGarden(bypassWall, offerType)

  if (showWall) return <>{wall}</>

  return <>{children}</>
}

export default SoftOfferPageWalledGarden
